import {registerLocaleData} from "@angular/common";
import {AppLocaleInitializerService} from "@shared/services/app-locale-initializer.service";
import {locales} from "./locales";


export function initializeAppLocale(initializer: AppLocaleInitializerService) {
  return async () => {
    await initializer.loadSettings();
    const localeId = initializer.locale;
    const localeLoader = locales[localeId];

    if (localeLoader) {
      // dynamic import of needed locale
      const localeDataModule = await localeLoader();
      registerLocaleData(localeDataModule.default);
      console.log(`Successfully registered locale: ${localeId}`);
    } else {
      console.warn(`Locale data for "${localeId}" not found. Using default 'sl-SI'.`);
      const defaultLocaleDataModule = await locales['sl-SI']();
      registerLocaleData(defaultLocaleDataModule.default);
    }
  };
}

